(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gd-card-actions"] && !Shopify.designMode) return;
  try {
    /* Global Duniya — product card buttons: option picker, Add to cart sync, Buy Now. */
  (function () {
    if (window.gdCardActionsReady) return;
    window.gdCardActionsReady = true;

    function syncCard(box, select) {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var id = opt.value;

      var input = box.querySelector('form input[name="id"]');
      if (input) input.value = id;

      var buy = box.querySelector('[data-gd-cbuy]');
      if (buy) buy.setAttribute('href', buy.getAttribute('data-cart-base') + id + ':1');

      var mediaUrl = opt.getAttribute('data-media-url');
      var atc = box.querySelector('add-to-cart-component');
      if (atc && mediaUrl) atc.setAttribute('data-product-variant-media', mediaUrl);

      var card = box.closest('product-card');
      if (!card) return;

      if (typeof card.applyVariantToLinks === 'function') {
        try { card.applyVariantToLinks(id); } catch (err) {}
      }

      var mediaId = opt.getAttribute('data-media-id');
      if (!mediaId) return;
      var slideshow = card.querySelector('slideshow-component');
      var slide = card.querySelector('slideshow-slide[slide-id="' + mediaId + '"]');
      if (!slideshow || !slide || typeof slideshow.select !== 'function') return;
      try {
        card.querySelectorAll('slideshow-slide[variant-image]').forEach(function (s) {
          s.hidden = s !== slide;
        });
        slide.hidden = false;
        slideshow.select({ id: mediaId }, undefined, { animate: false });
      } catch (err) {}
    }

    document.addEventListener('change', function (e) {
      var select = e.target;
      if (!select || !select.matches || !select.matches('[data-gd-cact-select]')) return;
      var box = select.closest('[data-gd-cact]');
      if (box) syncCard(box, select);
    });

    /* Capture phase so the card's own "open product" click never fires for Buy Now. */
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest && e.target.closest('[data-gd-cbuy]');
        if (!link) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        var box = link.closest('[data-gd-cact]');
        var input = box && box.querySelector('form input[name="id"]');
        var id = input && input.value;
        link.classList.add('is-loading');
        window.location.href = id ? link.getAttribute('data-cart-base') + id + ':1' : link.href;
      },
      true
    );

    /* Back/forward cache: clear the loading state when the shopper returns. */
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-gd-cbuy].is-loading').forEach(function (a) {
        a.classList.remove('is-loading');
      });
    });
  })();

  /* Global Duniya — colour-wise cards: har card apne colour par set hota hai, title mein colour dikhta hai. */
  (function () {
    if (window.gdVariantCardsReady) return;
    window.gdVariantCardsReady = true;

    function leafWithText(root, text) {
      var found = null;
      root.querySelectorAll('*').forEach(function (n) {
        if (found || n.children.length) return;
        if ((n.textContent || '').trim() === text) found = n;
      });
      return found;
    }

    function label(li) {
      var sel = li.querySelector('[data-gd-cact-select]');
      var card = li.querySelector('product-card');
      if (!sel || !card) return;
      var link = card.querySelector('.product-card__link');
      var base = li.getAttribute('data-gd-title');
      if (!base) {
        base = link ? link.getAttribute('aria-label') : '';
        if (!base) return;
        li.setAttribute('data-gd-title', base);
      }
      var el = li.querySelector('[data-gd-vtitle]') || leafWithText(card, base);
      if (!el) return;
      el.setAttribute('data-gd-vtitle', '');
      var opt = sel.options[sel.selectedIndex];
      var name = opt ? opt.textContent.replace(/\s+/g, ' ').trim() : '';
      var full = name ? base + ' – ' + name : base;
      el.textContent = full;
      if (link) link.setAttribute('aria-label', full);
    }

    function apply(li) {
      if (li.gdDone) return;
      var sel = li.querySelector('[data-gd-cact-select]');
      if (!sel) return;
      li.gdDone = true;
      var vid = li.getAttribute('data-gd-variant');
      if (vid && sel.value !== vid && sel.querySelector('option[value="' + vid + '"]')) {
        sel.value = vid;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      label(li);
    }

    function run(root) {
      (root || document).querySelectorAll('li[data-gd-variant]').forEach(apply);
    }

    function start() {
      var wait = ['product-card', 'slideshow-component'].map(function (n) {
        return window.customElements ? customElements.whenDefined(n) : Promise.resolve();
      });
      var timeout = new Promise(function (r) { setTimeout(r, 2500); });
      Promise.race([Promise.all(wait), timeout]).then(function () {
        requestAnimationFrame(function () { run(); });
      });
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('li[data-gd-variant]')) requestAnimationFrame(function () { apply(n); });
            else if (n.querySelectorAll) requestAnimationFrame(function () { run(n); });
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-gd-cact-select]')) return;
      var li = t.closest('li[data-gd-variant]');
      if (li) label(li);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
